<script>
import { uiState } from "@app/store/uiStore.svelte.js";
import {
    playerState
} from '@app/store/playerStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import { showModal } from '@app/store/modalStore.svelte.js';
import { setMediaImportSeed } from '@app/store/mediaImportStore.svelte.js';
import {lockState} from '@app/store/lockStore.svelte.js';
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    videoFilterState
} from '@app/store/videoFilterStore.svelte.js';

import EventEditorPreview from '../editor/events/EventEditorPreview.svelte';
import MediaPlayer from './MediaPlayer.svelte'
import GvMediaPlayer from './GvMediaPlayer.svelte'
import * as m from '@app/paraglide/messages.js';

let eventIndex = $state(-1);

function getDroppedFile(ev) {
    if (ev.dataTransfer?.items?.length) {
        return Array.from(ev.dataTransfer.items)
            .find((item) => item.kind === "file")
            ?.getAsFile();
    }

    return ev.dataTransfer?.files?.[0];
}

function importMedia(ev) {
    ev.preventDefault();
    let mediaFile = getDroppedFile(ev);
    if (!mediaFile) return;

    setMediaImportSeed({
        mediaSource: "Local Storage",
        files: [mediaFile],
    });
    showModal("mediaImport");
}

function selectEvent(index){
    eventGroupState[projectState.selected].selected = [index];
    if (lockState.video && eventGroupState[projectState.selected].events[index].start >= 0){
        player.currentTime = (eventGroupState[projectState.selected].events[index].start);
    }
}

$effect.pre(() => {
        // console.log("EFFECT Syncing Player with Event Group State...");
        eventIndex = playerState.previewEvent > -1 ? playerState.previewEvent : eventIndex;
    });
</script>

{#if uiState.listPreview && eventIndex > 0}
    <!-- Show the previous Event -->
    <a id="prevEventLink" role="button" aria-label={m.player_show_previous_event()} class="text-decoration-none" href="#!/" onclick={() => selectEvent(eventIndex -1)}>
        <EventEditorPreview eventIndex={eventIndex-1} height={64} rounded={false}></EventEditorPreview>
    </a>
{/if}
<!-- svelte-ignore a11y_no_static_element_interactions -->
<!-- svelte-ignore a11y_click_events_have_key_events -->
<!-- On double click - toggle fullscreen -->
<div id="PlayerWrapper" onclick={async() => {
        if (playerState.engine === "framelight") return;
        if (player && player.state.playing) {
            await player.pause();
        } else if (player) {
            await player.play();
        }
    }} style="filter: contrast({videoFilterState.contrast}%) saturate({videoFilterState.saturation}%) invert({videoFilterState.invert}%) brightness({videoFilterState.brightness}%);" ondrop={importMedia} ondragover={(ev) => { ev.preventDefault() }}>
    {#if playerState.engine === "framelight"}
        <GvMediaPlayer></GvMediaPlayer>
    {:else}
        <MediaPlayer></MediaPlayer>
    {/if}
</div>

{#if uiState.listPreview && eventIndex > -1 && eventIndex < eventGroupState[projectState.selected]?.events.length-1}
    <!-- Show the previous Event -->
     <a id="nextEventLink" role="button" aria-label={m.player_show_next_event()} class="text-decoration-none" href="#!/" onclick={() => selectEvent(eventIndex+1)}>
        <EventEditorPreview eventIndex={eventIndex+1} height={64} rounded={false}></EventEditorPreview>
    </a>
{/if}

<style>
#PlayerWrapper {
    position: relative;
    user-select: none;
}
</style>
